export enum DialogEvents {
  ClosedByClick = 'ClosedByClick',
  ClosedByTimeout = 'ClosedByTimeout',
  ClickedAccept = 'ClickedAccept',
  ClickedCancel = 'ClickedCancel',
}
